import { ReactNode } from "react";
import { BrowserRouter } from "react-router-dom";
import { StaticRouter } from "react-router";

interface RouterProviderProps {
  children: ReactNode;
  /** SSR-only: current request path (e.g. "/varovanje-podatkov"). */
  ssrLocation?: string;
}

export function RouterProvider({ children, ssrLocation }: RouterProviderProps) {
  if (typeof window === "undefined") {
    return <StaticRouter location={ssrLocation ?? "/"}>{children}</StaticRouter>;
  }

  return <BrowserRouter>{children}</BrowserRouter>;
}
